import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Box, Typography, Grid, Card, CardContent, Button, Snackbar, Alert, Chip, Avatar, FormControlLabel, Checkbox } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import DeleteIcon from '@mui/icons-material/Delete';
import AssessmentIcon from '@mui/icons-material/Assessment';
import PhotoLibraryIcon from '@mui/icons-material/PhotoLibrary';
import BarChartIcon from '@mui/icons-material/BarChart';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import ListAltIcon from '@mui/icons-material/ListAlt';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import URLManager from '../funcionalidadeNavbar/URLManager';
import PermissionGate from '../CadastroPerfilUsuario/PermissionGate';
import ConfirmationModal from '../components/ConfirmationModal';

export default function TesteCalceDashboard(){
  const _url = URLManager.getBaseURL();
  
  // Função para reenviar manualmente o link de avaliação
  const reenviarLink = async (id) => {
    if (!id) {
      setSnackbar({ open: true, severity: 'error', message: 'ID do teste não encontrado.' });
      return;
    }
    try {
      const res = await fetch(`${_url}/teste-calce/reenviar-link/${id}`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${sessionStorage.getItem('usuarioToken')}` }
      });
      if (!res.ok) {
        const txt = await res.text();
        setSnackbar({ open: true, severity: 'error', message: 'Falha ao reenviar: ' + txt });
      } else {
        setSnackbar({ open: true, severity: 'success', message: 'Link reenviado com sucesso!' });
      }
    } catch (e) {
      setSnackbar({ open: true, severity: 'error', message: 'Erro ao reenviar link.' });
    }
  };
  const location = useLocation();
  const navigate = useNavigate();
  const params = new URLSearchParams(location.search);
  const initialProdutoId = params.get('produtoId') || 'all';
  const [produtoId] = useState(initialProdutoId);
  const [data, setData] = useState([]);
  const [stats, setStats] = useState({});
  const [produtos, setProdutos] = useState([]);
  const [pendingOnly, setPendingOnly] = useState(false);
  const [snackbar, setSnackbar] = useState({ open:false, severity:'info', message:'' });
  const [expanded, setExpanded] = useState({});
  
  // Modal de confirmação
  const [modalConfirm, setModalConfirm] = useState({
    open: false,
    title: '',
    message: '',
    type: 'warning',
    onConfirm: null,
    confirmText: 'Confirmar',
    cancelText: 'Cancelar'
  });

  const STAT_FIELDS = React.useMemo(()=>[
    'img1_incomodando_calcanhar','img1_saindo_do_pe_ao_andar','img1_descolando_parte_traseira_da_sola','img1_normal',
    'img2_incomodando_frente','img2_incomodando_centro_do_pe','img2_incomodando_parte_de_tras','img2_solado_descolando','img2_normal',
    'img3_apertado','img3_pressionando_dedos','img3_solado_descolando_no_bico','img3_normal',
    'img4_incomodando_flexao','img4_cabedal_nao_flexiona','img4_solado_descolando_na_area_da_felxao','img4_normal',
    'img5_entrada_do_pe_com_dificuldade','img5_apertando_peito_pe','img5_folgado_peito_pe','img5_normal'
  ],[]);

  const IMG_LABELS = {
    1: 'Traseira',
    2: 'Solado',
  3: 'Bico',
  4: 'Flexao',
    5: 'Peito do Pé'
  };

  // IMG_ICONS removed (not used) to keep linter clean

  const keyToLabel = (k) => {
  // k like img1_incomodando_calcanhar
    const m = k.match(/^img(\d)_(.*)$/);
    if(!m) return k.replace(/_/g,' ');
    const imgNum = Number(m[1]);
    const capitalizeWords = (s) => s.split(' ').map(p => p ? (p.charAt(0).toUpperCase() + p.slice(1)) : '').join(' ');
    const rest = capitalizeWords(m[2].replace(/_/g,' '));
    return `${IMG_LABELS[imgNum] || ('Imagem '+imgNum)} - ${rest}`;
  };

  const fieldParts = (k) => {
    const m = k.match(/^img(\d)_(.*)$/);
    if(!m) return { imgNum: null, rest: k.replace(/_/g,' ') };
    const capitalizeWords = (s) => s.split(' ').map(p => p ? (p.charAt(0).toUpperCase() + p.slice(1)) : '').join(' ');
    return { imgNum: Number(m[1]), rest: capitalizeWords(m[2].replace(/_/g,' ')) };
  };

  const COLORS = ['#3f51b5','#ff7043','#ffca28','#66bb6a','#29b6f6','#ab47bc'];

  // modern style tokens
  const CARD_SX = { borderRadius: 2.5, background: 'linear-gradient(180deg, rgba(255,255,255,0.02), rgba(255,255,255,0.01))', border: '1px solid rgba(255,255,255,0.04)', boxShadow: '0 12px 30px rgba(2,6,23,0.08)' };
  const AVATAR_SX = { bgcolor: 'transparent', backgroundImage: 'linear-gradient(135deg,#7c4dff,#29b6f6)', color: '#fff', width: 40, height: 40 };
  const CHIP_PENDING_SX = { background: 'linear-gradient(90deg,#ffb74d,#ff7043)', color: '#fff', fontWeight: 700 };
  const CHIP_NOTIFIED_SX = { background: 'linear-gradient(90deg,#66bb6a,#29b6f6)', color: '#fff', fontWeight: 700 };
  const ACTION_BTN_SX = { borderRadius: 1.5, textTransform: 'none', boxShadow: '0 6px 18px rgba(47,79,255,0.06)' };

  // A tester is flagged if they marked any option different from "Normal"
  const hasAnyNonNormal = React.useCallback((item) => {
    if (!item) return false;
    return STAT_FIELDS.some(k => !k.endsWith('_normal') && !!item[k]);
  }, [STAT_FIELDS]);

  // Consider as responded when any of the flags (including "_normal") is true.
  // When o registro é criado, tudo vem false. Após responder, pelo menos um campo vira true.
  const hasResponded = React.useCallback((item) => {
    if (!item) return false;
    return STAT_FIELDS.some(k => !!item[k]);
  }, [STAT_FIELDS]);

  const makeConicGradient = (values, imgNum) => {
    const total = values.reduce((s, v) => s + (v || 0), 0);
    if (!total) return 'linear-gradient(#eee,#eee)';
    const parts = [];
    let acc = 0;
    values.forEach((v, idx) => {
      const pct = (v / total) * 100;
      const color = COLORS[((imgNum - 1) + idx) % COLORS.length] || '#ddd';
      parts.push(`${color} ${acc}% ${acc + pct}%`);
      acc += pct;
    });
    return `conic-gradient(${parts.join(',')})`;
  };

  const refresh = () => fetchData();

  const getSampleImage = (imgNum) => {
    // prefer product image when a product is selected
    let src = null;
    if(produtoId && produtoId !== 'all'){
      const product = produtos.find(p => String(p.id_produto || p.id) === String(produtoId));
      if(product){
        src = product.image || product.imagem || product.imagemPrincipal || product.imagem_produto || product.imagem1 || product.imagemUrl || product.imageUrl || null;
      }
    }
    if(!src && data && data.length > 0){
      for(const it of data){
        const cand = it && (it[`imagem${imgNum}`] || it[`imagem_${imgNum}`] || it[`image${imgNum}`] || it[`image${imgNum}Url`] || it[`imagem${imgNum}Url`]);
        if(cand){ src = cand; break; }
      }
    }
    if(src && typeof src === 'string' && !src.startsWith('http') && !src.startsWith('data:')){
      if(src.length > 80) src = `data:image/jpeg;base64,${src}`;
    }
    return src;
  }

  const computeStats = React.useCallback((list)=>{
    const s = {};
    // iterate and count positive/negative per question
    STAT_FIELDS.forEach(f => s[f] = 0);
    list.forEach(item => {
      STAT_FIELDS.forEach(f => {
        if(item[f]) s[f] = (s[f] || 0) + 1;
      })
    });
    setStats(s);
  },[STAT_FIELDS]);

  const fetchData = React.useCallback(async ()=>{
    try{
    let url = `${_url}/teste-calce`;
      // if produtoId is specified, prefer query param for unified endpoint handling in backend
  if(produtoId && produtoId !== 'all') url = `${_url}/teste-calce?produtoId=${encodeURIComponent(produtoId)}`;
  const res = await fetch(url, { headers: { Authorization: `Bearer ${sessionStorage.getItem('usuarioToken')}` } });
      if(!res.ok) return;
      const listRaw = await res.json();
      // dev logging
      if(process.env.NODE_ENV === 'development') console.debug('TesteCalceDashboard.fetchData sample', listRaw && listRaw[0]);

      // normalize keys: backend may return camelCase or snake_case
      const toCamel = (s) => s.replace(/_([a-z])/g, (_, c) => c.toUpperCase());
      const toSnake = (s) => s.replace(/[A-Z]/g, c => `_${c.toLowerCase()}`);

      const normalizeItem = (it) => {
        const out = { ...it };
        // ensure STAT_FIELDS are present on out: try snake, then camel
        STAT_FIELDS.forEach(k => {
          if(out[k] === undefined) {
            const camel = toCamel(k);
            if(it[camel] !== undefined) out[k] = it[camel];
            else if(it[toSnake(k)] !== undefined) out[k] = it[toSnake(k)];
          }
        });
        // normalize images imagem1..imagem5
        for(let i=1;i<=5;i++){
          const candidates = [`imagem${i}`, `imagem${i}Url`, `imagem_${i}`, `imagem${i}Base64`, `image${i}`, `image${i}Url`];
          if(out[`imagem${i}`] === undefined){
            for(const c of candidates){ if(it[c] !== undefined){ out[`imagem${i}`] = it[c]; break; } }
          }
        }
        return out;
      }

    const list = (listRaw || []).map(normalizeItem);
      setData(list);
      computeStats(list);
    }catch(e){}
  },[_url, produtoId, computeStats, STAT_FIELDS]);

  useEffect(()=>{
    fetchData();
  },[fetchData]);

  // derive displayed data according to pendingOnly
  const displayedData = React.useMemo(()=>{
    return pendingOnly ? (data || []).filter(d => !d.notified) : (data || []);
  },[data, pendingOnly]);

  // recompute stats for the displayed data (so the charts reflect the current filter)
  useEffect(()=>{
    computeStats(displayedData);
  },[displayedData, computeStats]);

  // Reload when window regains focus or tab becomes visible (user returns to dashboard)
  useEffect(()=>{
    const onFocus = () => fetchData();
    const onVisibility = () => { if (document.visibilityState === 'visible') fetchData(); };
    window.addEventListener('focus', onFocus);
    document.addEventListener('visibilitychange', onVisibility);
    return () => {
      window.removeEventListener('focus', onFocus);
      document.removeEventListener('visibilitychange', onVisibility);
    };
  },[fetchData]);
    useEffect(() => {
      // load products for select
    fetch(`${_url}/produto/pais`, { headers: { Authorization: `Bearer ${sessionStorage.getItem('usuarioToken')}` } })
        .then(r => r.json())
        .then(list => setProdutos(list || []))
        .catch(() => setProdutos([]));
    }, [_url]);

  

  const getPublicLink = (id) => `${window.location.origin}/qualidade/avaliar/${id}`;

  const copyLink = async (id) => {
    try{
      await navigator.clipboard.writeText(getPublicLink(id));
      setSnackbar({ open:true, severity:'success', message:'Link copiado para a área de transferência' });
    }catch(e){
      console.error(e);
      setSnackbar({ open:true, severity:'error', message:'Não foi possível copiar.' });
    }
  };

  const removeTest = async (id) => {
    if(!id) return;
    setModalConfirm({
      open: true,
      title: 'Remover Teste de Calce',
      message: 'Remover este teste de calce? Esta operação apagará também as imagens na AWS.',
      type: 'warning',
      confirmText: 'Sim, Remover',
      cancelText: 'Cancelar',
      onConfirm: async () => {
        setModalConfirm(prev => ({ ...prev, open: false }));
        try{
          const res = await fetch(`${_url}/teste-calce/remover/${id}`, { method: 'DELETE', headers: { Authorization: `Bearer ${sessionStorage.getItem('usuarioToken')}` } });
          if(!res.ok){
            const txt = await res.text();
            setSnackbar({ open:true, severity:'error', message: `Erro ao remover: ${txt}` });
          } else {
            setSnackbar({ open:true, severity:'success', message: 'Teste removido' });
            // refresh list
            fetchData();
          }
        }catch(e){
          console.error('removeTest error', e);
          setSnackbar({ open:true, severity:'error', message: 'Erro ao remover' });
        }
      }
    });
  };

  const shareWhatsApp = (id, text) => {
    const link = encodeURIComponent(getPublicLink(id));
    const msg = encodeURIComponent(text || 'Por favor avalie este produto: ')+ '%20' + link;
    window.open(`https://api.whatsapp.com/send?text=${msg}`, '_blank');
  };

  const ChartCircle = ({ values, imgNum, labels, sampleSrc }) => {
    const total = values.reduce((s,v)=>s+v,0);
    const gradient = makeConicGradient(values, imgNum);
    return (
      <Box sx={{ width: 240, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <div style={{ width: 110, height: 110, borderRadius: '50%', backgroundImage: gradient, boxShadow: 'inset 0 0 0 6px rgba(255,255,255,0.85)', border: '1px solid rgba(0,0,0,0.06)' }} title={`${total} respostas`} />
          <div style={{ width: 92, height: 92, borderRadius: 8, overflow: 'hidden', border: '1px solid #e0e0e0', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#fff' }}>
            {sampleSrc ? (
              <img src={sampleSrc} alt={IMG_LABELS[imgNum]} style={{ width: '100%', height: '100%', objectFit: 'contain', display: 'block' }} />
            ) : (
              <Typography variant="caption">Sem imagem</Typography>
            )}
          </div>
        </div>
        <Typography sx={{ fontSize: 13, fontWeight: 700 }}>{IMG_LABELS[imgNum]}</Typography>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6, width: '100%' }}>
          {labels.map((lab, idx) => (
            <div key={idx} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <div style={{ width: 12, height: 12, background: COLORS[((imgNum - 1) + idx) % COLORS.length], borderRadius: 3 }} />
                <Typography sx={{ fontSize: 12 }}>{lab}</Typography>
              </div>
              <Typography sx={{ fontSize: 12, fontWeight: 'bold' }}>{values[idx]}</Typography>
            </div>
          ))}
        </div>
      </Box>
    )
  }

  // thumbnails are rendered via React props (no DOM manipulation)

  const SectionHeader = ({ title, subtitle, icon }) => (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 1 }}>
      {icon && (
        <Box sx={{ width: 48, height: 48, borderRadius: 2, background: 'linear-gradient(135deg,#3f51b5,#7c4dff)', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 12px 30px rgba(79,70,229,0.18)', border: '1px solid rgba(255,255,255,0.06)' }}>
          {React.cloneElement(icon, { sx: { color: '#fff', fontSize: 22 } })}
        </Box>
      )}
      <Box>
        <Typography sx={{ fontWeight: 800, fontSize: 18, background: 'linear-gradient(90deg,#3f51b5,#29b6f6)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', letterSpacing: 0.2 }}>{title}</Typography>
        {subtitle && <Typography variant="caption" sx={{ display: 'block', color: '#6b7280' }}>{subtitle}</Typography>}
      </Box>
    </Box>
  );

  return (
    <Box sx={{ padding: 3 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Button size="small" startIcon={<ArrowBackIcon />} variant="outlined" onClick={()=> navigate(-1)}>
            Voltar
          </Button>
          <Box sx={{ width: 52, height: 52, borderRadius: 2, background: 'linear-gradient(135deg, #667eea, #29b6f6)', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 8px 20px rgba(102,126,234,0.15)' }}>
            <AssessmentIcon sx={{ color: '#fff', fontSize: 28 }} />
          </Box>
          <Box>
            <Typography variant="h5" sx={{
              fontWeight: 800,
              letterSpacing: 0.2,
              background: 'linear-gradient(90deg, #3f51b5, #29b6f6)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              textShadow: '0 6px 18px rgba(47,79,255,0.06)',
              '@keyframes floatTitle': {
                '0%': { transform: 'translateY(0px)' },
                '50%': { transform: 'translateY(-3px)' },
                '100%': { transform: 'translateY(0px)' }
              },
              animation: 'floatTitle 4s ease-in-out infinite'
            }}>Dashboard • Teste de Calce</Typography>
            <Typography variant="caption" sx={{ display: 'block', color: '#6b7280' }}>Painel — visão geral, análise e ações rápidas</Typography>
          </Box>
        </Box>
        <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
          <FormControlLabel control={<Checkbox checked={pendingOnly} onChange={e => setPendingOnly(e.target.checked)} size="small" />} label="Somente pendentes" />
          <Button size="small" variant="outlined" onClick={refresh}>Atualizar</Button>
        </Box>
      </Box>
      {produtoId && produtoId !== 'all' && (() => {
        const product = produtos.find(p => String(p.id_produto || p.id) === String(produtoId));
        if(!product) return null;
        const imgSrc = product.image ? (product.image.startsWith('http') ? product.image : `data:image/jpeg;base64,${product.image}`) : (product.imagem || product.imagem1 || product.imagemUrl || product.imageUrl || '');
        return (
          <Box sx={{ mt: 2, mb: 2 }}>
            <Card sx={{ display: 'flex', alignItems: 'center', gap: 2, padding: 1 }}>
              {imgSrc ? (
                <img src={imgSrc} alt={product.nomeModelo || product.nome_modelo || 'Produto'} style={{ width: 120, height: 80, objectFit: 'cover', borderRadius: 6 }} />
              ) : (
                <Box sx={{ width: 120, height: 80, display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#fafafa', borderRadius: 1 }}>Sem imagem</Box>
              )}
              <Box>
                <Typography sx={{ fontWeight: 'bold' }}>{product.nomeModelo || product.nome_modelo || product.nome_modelo}</Typography>
                <Typography variant="caption">Ref: {product.referencia || product.ref || ''}</Typography>
              </Box>
            </Card>
          </Box>
        )
      })()}
      {/* Modern aggregated horizontal chart */}
      <Box sx={{ mt: 2 }}>
        <SectionHeader title="Visão geral por imagem" subtitle="Distribuição rápida por tópico" icon={<BarChartIcon />} />
  {Object.keys(stats).length === 0 ? (
          <Typography variant="caption">Sem dados para construir gráfico</Typography>
        ) : (
          <Box sx={{ mt:1, p:2, border: '1px solid #f0f0f0', borderRadius: 2, background: '#fafafa' }}>
                {/* Legend removed as requested */}
            <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', justifyContent: 'space-between' }}>
              {[1,2,3,4,5].map(imgNum => {
                const keys = STAT_FIELDS.filter(k => k.startsWith(`img${imgNum}`));
                const values = keys.map(k => stats[k] || 0);
                const labels = keys.map(k => keyToLabel(k).split('-').slice(1).join('-').trim());
                const sample = getSampleImage(imgNum);
                return (
                  <ChartCircle key={imgNum} values={values} imgNum={imgNum} labels={labels} sampleSrc={sample} />
                )
              })}
            </div>
          </Box>
        )}
      </Box>
      {/* removed product search select as requested */}

      <Box sx={{ mt: 3 }}>
        <SectionHeader title="Resumo (contagens)" subtitle="Contagem de flags por tópico" icon={<ListAltIcon />} />
        {Object.keys(stats).length === 0 ? (
          <Typography>Nenhum dado</Typography>
        ) : (
          <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: 12, marginTop: 12 }}>
            {[1,2,3,4,5].map(imgNum => {
              const keys = STAT_FIELDS.filter(k => k.startsWith(`img${imgNum}`));
              return (
                <Box key={imgNum} sx={{ border: '1px solid #eee', padding: 2, borderRadius: 2, background: '#fff' }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                    <Chip label={IMG_LABELS[imgNum]} size="small" sx={{ bgcolor: COLORS[(imgNum-1) % COLORS.length], color: '#fff' }} />
                    <Typography sx={{ fontWeight: 700 }}>{IMG_LABELS[imgNum]}</Typography>
                  </Box>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                    {keys.map(k => {
                      const p = fieldParts(k);
                      return (
                        <Box key={k} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                          <Typography sx={{ fontSize: 13 }}>{p.rest}</Typography>
                          <Typography sx={{ fontWeight: 'bold' }}>{stats[k] || 0}</Typography>
                        </Box>
                      )
                    })}
                  </div>
                </Box>
              )
            })}
          </Box>
        )}
      </Box>

      <Box sx={{ mt: 4 }}>
        <SectionHeader title="Aguardando Avaliação" subtitle="Registros não notificados" icon={<HourglassEmptyIcon />} />
        <PermissionGate permissions={["listarTodos"]}>
        <Grid container spacing={2} sx={{ mt: 1 }}>
          {displayedData.filter(d => !d.notified).map(item => (
            <Grid item xs={12} md={6} key={item.id}>
              <Card sx={CARD_SX}>
                <CardContent>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    <Avatar sx={{ ...AVATAR_SX, border: hasAnyNonNormal(item) ? '2px solid #d32f2f' : undefined }}>
                      {(item.nome || 'T').charAt(0)}
                    </Avatar>
                    <Box sx={{ flex: 1 }}>
                      <Typography sx={{ fontWeight: 'bold', color: hasAnyNonNormal(item) ? 'error.main' : undefined }}>{item.produtoNomeModelo}</Typography>
                      <Typography variant="body2" sx={{ color: hasAnyNonNormal(item) ? 'error.main' : undefined }}>{item.nome} • {item.telefoneWhatsapp}</Typography>
                    </Box>
                    <Chip label={item.notified ? 'Notificado' : 'Pendente'} size="small" sx={item.notified ? CHIP_NOTIFIED_SX : CHIP_PENDING_SX} />
                    <Chip label={hasResponded(item) ? 'Respondido' : 'Não respondido'} size="small" color={hasResponded(item) ? 'success' : 'default'} variant="outlined" />
                    {hasAnyNonNormal(item) && (
                      <Chip label="Com observações" size="small" color="error" />
                    )}
                  </Box>
                  <Box sx={{ mt: 1 }}>
                    <Typography variant="caption">Última notificação: {item.lastNotifiedAt || item.notifiedAt || (item.notified ? '—' : 'Nunca')}</Typography>
                  </Box>
                  <Box sx={{ mt:1, display: 'flex', gap: 1 }}>
                    <PermissionGate permissions={["cadastrarTesteCalce"]}>
                      <Button size="small" variant="outlined" onClick={()=> copyLink(item.id)} startIcon={<ContentCopyIcon />} sx={ACTION_BTN_SX}>Copiar link</Button>
                      <Button size="small" variant="contained" color="success" onClick={()=> shareWhatsApp(item.id, `Avalie o teste para ${item.produtoNomeModelo}`)} startIcon={<WhatsAppIcon />} sx={ACTION_BTN_SX}>WhatsApp</Button>
                      <Button size="small" variant="contained" color="secondary" onClick={()=> reenviarLink(item.id)} sx={ACTION_BTN_SX}>Reenviar link</Button>
                      <Button size="small" variant="outlined" color="error" onClick={()=> removeTest(item.id)} startIcon={<DeleteIcon />} sx={ACTION_BTN_SX}>Remover</Button>
                      <Button size="small" variant="text" onClick={()=> setExpanded(e=>({...e, [item.id]: !e[item.id]}))} sx={ACTION_BTN_SX}>{expanded[item.id] ? 'Ocultar avaliação' : 'Ver avaliação'}</Button>
                    </PermissionGate>
                  </Box>
                  {expanded[item.id] && (
                    <Box sx={{ mt:2, borderTop: '1px solid #eee', pt:2 }}>
                      <Typography variant="subtitle2">Respostas</Typography>
                      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 8 }}>
                        {STAT_FIELDS.map(k => {
                          const p = fieldParts(k);
                          return (
                            <Box key={k} sx={{ border: '1px solid #f1f1f1', p:1, borderRadius:1, display: 'flex', alignItems: 'center', gap:1 }}>
                              <Chip label={IMG_LABELS[p.imgNum]} size="small" sx={{ bgcolor: COLORS[((p.imgNum||1)-1) % COLORS.length], color: '#fff', mr:1 }} />
                              <Box sx={{ flex: 1 }}>
                                <Typography sx={{ fontSize: 12 }}>{p.rest}</Typography>
                                <Typography sx={{ fontWeight: 'bold' }}>{item[k] ? 'Sim' : 'Não'}</Typography>
                              </Box>
                            </Box>
                          )
                        })}
                      </div>
                      <Box sx={{ mt: 2 }}>
                        <Typography variant="subtitle2">Imagens</Typography>
                        <div style={{ display: 'flex', gap: 8, marginTop: 8 }}>
                          {[1,2,3,4,5].map(i => (
                            <div key={i} style={{ width: 100, height: 100, border: '1px solid #ddd', position: 'relative', overflow: 'hidden' }}>
                              {item[`imagem${i}`] ? (
                                <>
                                  <img src={item[`imagem${i}`]} alt={IMG_LABELS[i]} style={{ maxWidth: '100%', maxHeight: '100%', display: 'block' }} />
                                  <div style={{ position: 'absolute', left: 6, top: 6 }}>
                                    <Chip label={IMG_LABELS[i]} size="small" sx={{ bgcolor: COLORS[(i-1) % COLORS.length], color: '#fff' }} />
                                  </div>
                                </>
                              ) : (
                                <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                  <Typography variant="caption">Sem imagem</Typography>
                                </div>
                              )}
                            </div>
                          ))}
                        </div>
                      </Box>
                    </Box>
                  )}
                </CardContent>
              </Card>
            </Grid>
          ))}
  </Grid>
  </PermissionGate>

        <Box sx={{ mt: 4 }}>
          <SectionHeader title="Registros (todos)" subtitle="Todos os testes registrados" icon={<PhotoLibraryIcon />} />
        </Box>
        <PermissionGate permissions={["listarTodos"]}>
        <Grid container spacing={2} sx={{ mt: 1 }}>
          {displayedData.map(item => (
            <Grid item xs={12} md={6} key={item.id}>
              <Card sx={CARD_SX}>
                <CardContent>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    <Avatar sx={{ bgcolor: '#f5f5f5', border: hasAnyNonNormal(item) ? '2px solid #d32f2f' : undefined }}>{(item.nome || 'T').charAt(0)}</Avatar>
                    <Box sx={{ flex: 1 }}>
                      <Typography sx={{ fontWeight: 'bold', color: hasAnyNonNormal(item) ? 'error.main' : undefined }}>{item.produtoNomeModelo}</Typography>
                      <Typography variant="body2" sx={{ color: hasAnyNonNormal(item) ? 'error.main' : undefined }}>{item.nome} • {item.telefoneWhatsapp}</Typography>
                    </Box>
                    <Chip label={item.notified ? 'Notificado' : 'Pendente'} color={item.notified ? 'success' : 'warning'} size="small" />
                    <Chip label={hasResponded(item) ? 'Respondido' : 'Não respondido'} size="small" color={hasResponded(item) ? 'success' : 'default'} variant="outlined" />
                    {hasAnyNonNormal(item) && (
                      <Chip label="Com observações" size="small" color="error" />
                    )}
                  </Box>
                  <Box sx={{ mt: 1 }}>
                    <Typography variant="caption">Última notificação: {item.lastNotifiedAt || item.notifiedAt || (item.notified ? '—' : 'Nunca')}</Typography>
                  </Box>
                  <Box sx={{ mt:1, display: 'flex', gap: 1 }}>
                    <Button size="small" variant="outlined" onClick={()=> copyLink(item.id)} startIcon={<ContentCopyIcon />}>Copiar link</Button>
                    <Button size="small" variant="contained" color="success" onClick={()=> shareWhatsApp(item.id, `Avalie o teste para ${item.produtoNomeModelo}`)} startIcon={<WhatsAppIcon />}>WhatsApp</Button>
                    <Button size="small" variant="contained" color="secondary" onClick={()=> reenviarLink(item.id)}>Reenviar link</Button>
                    <Button size="small" variant="outlined" color="error" onClick={()=> removeTest(item.id)} startIcon={<DeleteIcon />}>Remover</Button>
                    <Button size="small" variant="text" onClick={()=> setExpanded(e=>({...e, [item.id]: !e[item.id]}))}>{expanded[item.id] ? 'Ocultar avaliação' : 'Ver avaliação'}</Button>
                  </Box>
                  {expanded[item.id] && (
                    <Box sx={{ mt:2, borderTop: '1px solid #eee', pt:2 }}>
                      <Typography variant="subtitle2">Respostas</Typography>
                      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 8 }}>
                        {STAT_FIELDS.map(k => {
                          const p = fieldParts(k);
                          return (
                            <Box key={k} sx={{ border: '1px solid #f1f1f1', p:1, borderRadius:1, display: 'flex', alignItems: 'center', gap:1 }}>
                              <Chip label={IMG_LABELS[p.imgNum]} size="small" sx={{ bgcolor: COLORS[((p.imgNum||1)-1) % COLORS.length], color: '#fff', mr:1 }} />
                              <Box sx={{ flex: 1 }}>
                                <Typography sx={{ fontSize: 12 }}>{p.rest}</Typography>
                                <Typography sx={{ fontWeight: 'bold' }}>{item[k] ? 'Sim' : 'Não'}</Typography>
                              </Box>
                            </Box>
                          )
                        })}
                      </div>
                      <Box sx={{ mt: 2 }}>
                        <Typography variant="subtitle2">Imagens</Typography>
                        <div style={{ display: 'flex', gap: 8, marginTop: 8 }}>
                          {[1,2,3,4,5].map(i => (
                            <div key={i} style={{ width: 100, height: 100, border: '1px solid #ddd', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                              {item[`imagem${i}`] ? <img src={item[`imagem${i}`]} alt={`img${i}`} style={{ maxWidth: '100%', maxHeight: '100%' }} /> : <Typography variant="caption">Sem imagem</Typography>}
                            </div>
                          ))}
                        </div>
                      </Box>
                    </Box>
                  )}
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
        </PermissionGate>
      </Box>
      <Snackbar open={snackbar.open} autoHideDuration={3000} onClose={()=>setSnackbar(s=>({...s, open:false}))}>
        <Alert severity={snackbar.severity} sx={{ width: '100%' }}>{snackbar.message}</Alert>
      </Snackbar>

      {/* Modal de Confirmação */}
      <ConfirmationModal
        open={modalConfirm.open}
        title={modalConfirm.title}
        message={modalConfirm.message}
        type={modalConfirm.type}
        confirmText={modalConfirm.confirmText}
        cancelText={modalConfirm.cancelText}
        onConfirm={() => {
          modalConfirm.onConfirm && modalConfirm.onConfirm();
        }}
        onCancel={() => setModalConfirm(prev => ({ ...prev, open: false }))}
      />
    </Box>
  );
}
